import { APPS_HEIGHT_MAX, APPS_HEIGHT_MIN } from './appsSectionTokens.js'

export function appsResizeKeyDown(e, appsHeightPx, setAppsHeightPx) {
  const STEP = e.shiftKey ? 24 : 8
  let next = null
  if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = appsHeightPx - STEP
  else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = appsHeightPx + STEP
  else if (e.key === 'Home') next = APPS_HEIGHT_MIN
  else if (e.key === 'End') next = APPS_HEIGHT_MAX
  else if (e.key === 'PageUp') next = appsHeightPx - 64
  else if (e.key === 'PageDown') next = appsHeightPx + 64
  if (next == null) return false
  e.preventDefault()
  setAppsHeightPx(Math.round(Math.min(APPS_HEIGHT_MAX, Math.max(APPS_HEIGHT_MIN, next))))
  return true
}
